import { Component } from '@angular/core';

@Component({
    templateUrl: 'server-error.view.html',
    styleUrls: ['../not-found/not-found.style.scss'],
})
export class ServerErrorView {}
